export class AreaMapRequest {
    public areaType: number;
    public id: number;
    public grades: number[];
    public programsOffered: number[];
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/area-map-request.ts